import Header from "./Header";
import Footer from "./Footer";

export const Layout = ({ children }) => (
  <div className="App min-h-screen flex flex-col bg-white">
    <Header />
    <main className="flex-1 pt-24">{children}</main>
    <Footer />
  </div>
);

export default Layout;
